import axiosIns from "@/api/axios";

export const GET_ALL_DATA = (args) => {
  return axiosIns.get(`quesioner?${args}`);
};

export const ADD_DATA = (args) => {
  return axiosIns.post(`quesioner/create`, args);
};

export const UPDATE_DATA = (args) => {
  return axiosIns.put(`quesioner/${args.id}/update`, args);
};

export const DELETE_DATA = (id) => {
  return axiosIns.delete(`quesioner/${id}/delete`);
};

export const GET_DEFAULT = () => {
  return axiosIns.get(`quesioner/default`);
};

export const GET_DETAIL = (id) => {
  return axiosIns.get(`quesioner/${id}/detail`);
};

export const GET_VALIDATION = (id) => {
  return axiosIns.get(`ideation/${id}/is-valid`);
};

export const SUBMIT_VALIDATE1 = (args) => {
  return axiosIns.post(`/gentagendis/validate`, args);
};

export const SUBMIT_VALIDATE_BUSINESS_TF = (args) => {
  return axiosIns.post(`/ideation/${args.ideation_id}/bt/validate`, args.body);
};

export const SUBMIT_VALIDATE2 = (args) => {
  return axiosIns.post(`/gentagendis/createQuesioner`, args);
};

export const GET_QUESIONER_GG = (id) => {
  return axiosIns.get(`/ideation/${id}/get-by-gg`);
};